import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import ka from './assets/ka.jpg'
import mis from './assets/mis.jfif'
import srch from './assets/srch.png'
import lvbt from './assets/lvbt.png'
import mir from './assets/mir.png'
import cnsl from './assets/cnsl.png'
import lot from './assets/lot.png'
import nrc from './assets/nrc.jpg'
import island from './assets/island.jfif'
import ds from './assets/DS.png'
import ms from './assets/ms.png'
import md from './assets/md.PNG'
import fndEle from './assets/fndEle.png'
import bmp from './assets/bmp.png'
const Ola = () => {
    return (
        <div>
             <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={ka}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Kadane’s Algorithm</p>
      <NavLink to='/category/Ola Cabs Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  

  
  <div class="card 1">
    <div class="card_image">
      <img src={mis} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Missing number in array</p>
        <NavLink to='/category/Ola Cabs Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
  
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src='' /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Sort an array of 0s, 1s and 2s</p>
      <NavLink to='/category/Ola Cabs Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={srch} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Search in a matrix</p>
      <NavLink to='/category/Ola Cabs Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={lvbt} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Left View of Binary Tree</p>
        <NavLink to='/category/Ola Cabs Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={mir} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Mirror Tree</p>
      <NavLink to='/category/Ola Cabs Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
   
  
    <div class="card 4">
    <div class="card_image">
      <img src={cnsl} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Connect Nodes at Same Level</p>
      <NavLink to='/category/Ola Cabs Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={ds} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>K distance from root</p>
        <NavLink to='/category/Ola Cabs Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={lot} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Level order traversal in spiral form</p>
      <NavLink to='/category/Ola Cabs Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={nrc} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Non Repeating Character</p>
      <NavLink to='/category/Ola Cabs Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={island} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Find the number of islands</p>
        <NavLink to='/category/Ola Cabs Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={ms} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Find the character in first string that is present at minimum index in second string</p>
      <NavLink to='/category/Ola Cabs Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
    <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
    <div class="card 3">
      <div class="card_image"> <img src={md} /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Maximum difference between two elements such that larger element appears after the smaller number</p>
        <NavLink to='/category/Ola Cabs Interview question 13'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
      </div>
    </div>
    <div class="card 3">
      <div class="card_image"> <img src={fndEle} /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Find the element that appears once in sorted array</p>
        <NavLink to='/category/Ola Cabs Interview question 14'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
          </div>
      </div>
    <div class="card 4">
      <div class="card_image"> <img src={bmp} /> </div>
      <div class="card_title title-white">
        <p style={{fontSize:'1rem'}}>Boolean Matrix Problem</p>
        <NavLink to='/category/Ola Cabs Interview question 15'>
      <Button  variant="contained" color="primary" >
            Dive-In
          </Button></NavLink>
          </div>
      </div>
    </div>
    </div>
       </div>  
        </div>
    )
}

export default Ola
